import { Clock } from "lucide-react";

/** The snapshot's refresh cadence (jobs-rollup landing-snapshot CronJob, every 30 minutes). */
const REFRESH_MINUTES = 30;

/** "29 Oct, 11:30 am" in the store's zone — or the viewer's, before the API has named one. */
export function formatDataAsOf(dataAsOf: string, timezone: string | null): string {
  return new Date(dataAsOf).toLocaleString("en-IN", {
    day: "numeric",
    month: "short",
    hour: "numeric",
    minute: "2-digit",
    ...(timezone === null ? {} : { timeZone: timezone }),
  });
}

/**
 * WHEN THESE FIGURES ARE FROM (2026-10-29). Landing Page Analysis serves a preset range from a snapshot
 * rebuilt every 30 minutes, so today's figures stop at the last build. Saying so keeps that lag from
 * reading as missing data — QA read a window ending today as "today has no data". Nothing is shown for
 * a live answer (dataAsOf null): it is current.
 */
export function DataAsOfNote({
  dataAsOf,
  timezone,
}: {
  readonly dataAsOf: string | null | undefined;
  readonly timezone: string | null;
}): React.JSX.Element | null {
  if (dataAsOf === null || dataAsOf === undefined) return null;
  return (
    <p data-testid="data-as-of" className="text-muted-foreground flex items-center gap-1.5 text-xs">
      <Clock className="size-3.5" aria-hidden />
      Figures as of {formatDataAsOf(dataAsOf, timezone)}, refreshed every {REFRESH_MINUTES} minutes.
    </p>
  );
}
